/*
 * BrightLabs Proprietary Limited (c) 2021
 * https://www.brightlabs.co.bw
 * info@brightlabs.co.bw
 */

import React from "react";
import {Stack} from "@fluentui/react";
import Slide from 'react-reveal';

import hero from "../../images/illustrations/services_dev_android.svg";

import Page from "../shared/Page";
import helpers from "../../k/helpers";
import Hero from "../shared/Hero";
import ServicePage from "../shared/ServicePage";


class HeroContent extends React.Component<any, any> {

    public render() {

        const
            padding = helpers.padding();

        return (
            <Stack tokens={{childrenGap: padding}}>

                <Stack>

                    <Slide left>
                        <Stack tokens={{childrenGap: -16}}>
                            <h4>
                                {helpers.links.services.text}
                            </h4>

                            <h1>
                                {helpers.links.android_dev.text}
                            </h1>
                        </Stack>
                    </Slide>

                    <Slide right>
                        <h2>
                            We build stunning applications that run smoothly on each device.
                        </h2>
                    </Slide>

                </Stack>

                <Slide bottom>
                    <Stack verticalFill={true} verticalAlign={'center'} horizontalAlign={'center'}>
                        <h3>
                            Using Google’s latest technologies, our Android app development team delivers 100% native
                            and reliable high-quality apps, with seamless integration with your backend.
                        </h3>
                    </Stack>
                </Slide>

            </Stack>
        );
    }
}

class AdditionalContent extends React.Component<any, any> {
    render() {
        return null;
    }
}

export default class AndroidDev extends ServicePage {

    public render() {

        const
            backgroundColor = 'rgba(0, 0, 0, 0.003)',
            backgroundSize = '25%',

            title = "BrightLabs | " + helpers.links.android_dev.text,
            url = helpers.links.android_dev.url,
            description = "Impactful Android app development";

        return (
            <Page title={title} description={description} url={url}>

                <Hero backgroundColor={backgroundColor} backgroundSize={backgroundSize} hero={hero}>
                    <HeroContent />
                </Hero>

                <AdditionalContent />
            </Page>
        );
    }
}
